<div class="row">
  <div class="col-md-8">
    <fieldset class="border rounded-3 p-3 mt-3">
      <legend class="subtitle-4 float-none w-auto px-3">
        Supplemental Loads
      </legend>
      <div class="container">
       
          
          <div class="form-group row align-items-center mb-2">
            <label class="col-sm-8">
              Vertical load acting at lower edge of metal loss, F<sub>y.ml</sub>
              ({{ fmlUnit }})
            </label>
            <div class="col-sm-4">
              <input
                type="number"
                class="form-control"
                id="fml"
                [value]="displayFml"
                (input)="onFmlChange($event.target.value)"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mb-2">
            <label class="col-sm-8">
              Bending moment acting at lower edge of metal loss, M<sub>z.ml</sub>
              ({{ mmlUnit }})
            </label>
            <div class="col-sm-4">
              <input
                type="number"
                class="form-control"
                id="mml"
                [value]="displayMml"
                (input)="onMmlChange($event.target.value)"
                min="0"
              />
            </div>
          </div>
        
      </div>
    </fieldset>
  </div>
  <div class="col-md-4">
    <img [src]="imageUrl" class="img-fluid img-thumbnail" [alt]="imageAlt" />
  </div>
</div>

<button
  class="btn btn-primary no-arrow float-left"
  (click)="onBack()"
>
  <span class="icon-chevron-left"></span>
  &nbsp;Back
</button>
<button
  class="btn btn-primary no-arrow float-right arrow"
  (click)="onNext()"
>
  Next&nbsp;
  <span class="icon-chevron-right"></span>
</button>
